import useSWR from 'swr'

import { MutationOptions, useCallMutation } from '@/common/api/client'
import {
  ConsentSummaryResponse,
  ConsentSummaryVars,
  DeletePreviewResponse,
  DeletePreviewVars,
  DeleteRequestResponse,
  DeleteRequestVars,
  UGCComplianceApiPath
} from '@/common/api/params/ugcCompliance'

/** 削除プレビュー（読み取りのみ）。vars が undefined の間は取得しない */
export const useDeletePreviewApi = (vars: DeletePreviewVars | undefined) => {
  return useSWR<DeletePreviewResponse, Response, [string, DeletePreviewVars] | undefined>(
    vars ? [UGCComplianceApiPath.GET_DELETE_PREVIEW, vars] : undefined
  )
}

/** 削除の実行（監査ログに記録される） */
export const useDeleteRequestApi = (options?: MutationOptions<DeleteRequestResponse>) => {
  return useCallMutation<DeleteRequestResponse, DeleteRequestVars>(
    UGCComplianceApiPath.DELETE_REQUEST,
    options
  )
}

export const useConsentSummaryApi = (vars: ConsentSummaryVars | undefined) => {
  return useSWR<ConsentSummaryResponse, Response, [string, ConsentSummaryVars] | undefined>(
    vars ? [UGCComplianceApiPath.GET_CONSENT_SUMMARY, vars] : undefined
  )
}
